import { Link } from "@tanstack/react-router";
import { ArrowRight, Clock } from "lucide-react";
import { type BlogPost, getCategory } from "@/data/blog";
import { getPostImage } from "@/data/blogImages";

export function BlogCard({ post }: { post: BlogPost }) {
  const category = getCategory(post.category);
  const image = getPostImage(post.slug);
  return (
    <Link
      to="/blog/$category/$slug"
      params={{ category: post.category, slug: post.slug }}
      className="group flex flex-col overflow-hidden rounded-2xl border border-border bg-card shadow-card transition-all hover:-translate-y-1 hover:shadow-card-hover"
    >
      <div className="aspect-[16/9] w-full overflow-hidden bg-muted">
        <img
          src={image}
          alt={`${category?.name ?? "Blog"} illustration`}
          width={1024}
          height={576}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col p-6">
        <div className="flex items-center gap-3 text-xs">
          <span className="rounded-full bg-accent/20 px-2.5 py-1 font-semibold text-accent-foreground">
            {category?.name}
          </span>
          <span className="flex items-center gap-1 text-muted-foreground">
            <Clock className="h-3 w-3" /> {post.readTime}
          </span>
        </div>
        <h2 className="mt-4 text-lg font-semibold leading-snug group-hover:text-primary-glow">
          {post.title}
        </h2>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-muted-foreground">{post.excerpt}</p>
        <div className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-glow">
          Read guide
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
        </div>
      </div>
    </Link>
  );
}
